export default {
  sm: `
  데이터센터 각의 지향점
  `
};
